export const setDeviceQuery = async (data, csrf_token) => {
    return fetch('/domains/add-domain-gsc-data/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const addUsers = async (data) => {
    return fetch('/customers/add-viewer/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const getUsers = async () => {
    return fetch('/api/v1/viewers/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const deleteUser = async (id) => {
    return fetch(`/api/v1/viewers/${id}/`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const updateProfile = async (data, csrf_token) => {
    return fetch('/customers/change-customer-profile-api/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrf_token,
        },
        body: JSON.stringify(data),
    });
};
